import { createElement } from "react";
import Collapsible from "./Collapsible/Collapsible";
import CustomComponent from "./CustomComponent";

/**
 * A `<collapsible>` custom component, which displays a collapsible section
 * around its child components. It has the following attributes:
 *
 *   * `title` - (Required) The title of the section.
 *   * `open` - (Optional) True if the section is initially open.
 */
export default class CollapsibleCustomComponent extends CustomComponent {
  get name() {
    return "collapsible";
  }
  get attributes() {
    return ["title", "open", "rightbtn", "btnstyle"];
  }
  processNode(_context, node, children) {
    var _node$attribs, _node$attribs2;
    const title = node.attribs && node.attribs.title ? node.attribs.title : "Collapsible";
    const isOpen = node.attribs ? Boolean(node.attribs.open) : false;
    const btnRight = Boolean((_node$attribs = node.attribs) === null || _node$attribs === void 0 ? void 0 : _node$attribs.rightbtn);
    const btnStyle = (_node$attribs2 = node.attribs) === null || _node$attribs2 === void 0 ? void 0 : _node$attribs2.btnstyle;
    return /*#__PURE__*/createElement(Collapsible, {
      key: title,
      title,
      isOpen,
      btnRight,
      btnStyle: btnStyle === "plus" ? "plus" : undefined
    }, children);
  }
}